import React from 'react';

import RelevantItemsSection from 'relevant-items/RelevantItemsSection';

interface Props {
  fileId: string;
}

export default function RelevantItemsView(props: Props): JSX.Element {
  return (
    <div className="react-tab-container">
      <RelevantItemsSection fileId={props.fileId} />
    </div>
  );
}
